import { styled } from "@mui/material";

export const ExpandIconDiv = styled("div")({
  position: "absolute",
  left: 0,
  right: 0,
  bottom: -6,
  textAlign: "center",
});
